export default __webpack_public_path__ + "static/media/ishay-merling.e71623b5.png";